"use client"

import { GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  contactForm: GetPageByRouteQuery
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  operatingLeasingBlock: () => import("@eurodrive/ui/TextImageBlock"),
  amongOurClients: () => import("./AmongOurClients"),
  selectContactForm: () => import("@eurodrive/ui/FormBlock"),
}

export default function OperatingLeasing({ data, contactForm, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages") {
          blockProps = { breadCrumbs }
        }
        if (block.blockType === "selectContactForm") {
          blockProps = { contactForm }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
